import { memoize } from '@dbh/lodash-extra';

const THEME_KEY_HIGHLIGHTED_SERVICES="highlightedServices";const modifyHighlightedServicesTheme=memoize(a=>{let{colors:{blackMid:b,brandSeventh:c},fonts:{size:{ff7:d,ff8:e}}}=a;return {[THEME_KEY_HIGHLIGHTED_SERVICES]:{fontSize:d,palette:{color:b},canBeBookedPalette:{color:c},includeLabel:{fontSize:e}}}});

export { THEME_KEY_HIGHLIGHTED_SERVICES, modifyHighlightedServicesTheme as default };
